import React, { useRef } from 'react';
import css from './SectionDynamicFeaturedListing.module.css';
import NewListingCard from './NewListingCard';

export const SectionDynamicFeaturedListing = ({
  listings = [],
  title = 'Featured Listings',
  isLoading = false,
  error = null,
}) => {
  const carouselRef = useRef(null);

  const scroll = scrollOffset => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft += scrollOffset;
    }
  };

  return (
    <div className={css.section}>
      <div className={css.landingListingBlock}>
      <h2 className={css.heading}>{title}</h2>

      {isLoading ? (
        <div className={css.status}>Loading listings...</div>
      ) : error ? (
        <div className={css.statusError}>Error loading listings.</div>
      ) : listings.length === 0 ? (
        <div className={css.status}>No listings available.</div>
      ) : (
        <div className={css.carouselContainer}>
          <button
            className={`${css.navButton} ${css.left}`}
            onClick={() => scroll(-250)}
            aria-label="Scroll left"
          >
          ‹
          </button>

          <div className={css.carousel} ref={carouselRef}>
            {listings.map(listing => (
              <NewListingCard listing={listing} key={listing.id?.uuid} />
            ))}
          </div>

          <button
            className={`${css.navButton} ${css.right}`}
            onClick={() => scroll(250)}
            aria-label="Scroll right"
          >
           ›
          </button>
        </div>
      )}
    </div>
    </div>
  );
};

export default SectionDynamicFeaturedListing;
